import axios from 'axios';
import _ from 'lodash';
import { Utils } from '../utils';
import { baseURL, smartfactoryURL } from './Constants';

// Interceptor for request
axios.interceptors.request.use(
    (config) => {
      let token = localStorage.getItem('token');
       if(token !== null || token !== undefined) {
         let language = localStorage.getItem("i18nextLng")
         let requestParameter = {
            'Content-Type': 'application/json',
            'X-Authorization': `Bearer ${token}`,
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
            'Pragma':'no-cache',
            'Cache-Control':'no-cache',
            'Language':`${language}`
         };
         config.headers = { ...config.headers, ...requestParameter };
       }
       // Add configurations here
       return config;
    },
    (errorConfig) => {
       return Promise.reject(errorConfig);
    }
 );
 
 // Interceptor for response
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (err, status) => {
    console.log(err?.request, err?.response);
    if(err?.response?.status){
      console.log(' - - - - - - - ERROR STATUS - - - -- - - ', err.response.status);
      let redirectStatus = [401, 403];
      if(_.includes(redirectStatus, err.response.status)) {
        Utils.clearTokens();
        window.location.href = "/";
      }
    }
    return Promise.reject(err);
  }
);

export const PostData = (url, requestParameters, isLogin) => {
  let siteUrl;
  if(isLogin) {
    siteUrl = `${baseURL}${url}`;
  } else {
    siteUrl = `${smartfactoryURL}${url}`;
  }
  return axios.post(siteUrl, requestParameters);
}

export const GetData = (url, isLogin) => {
  let siteUrl;
  if(isLogin) {
    siteUrl = `${baseURL}${url}`;
  } else {
    siteUrl = `${smartfactoryURL}${url}`;
  }
  return axios.get(siteUrl);
}